// The visitor's choices, kept in the browser: the theme ( else night from 19:00 to 7:00 ) and the language ( else the browser's )
export const LANGS = [ "fr", "en", "es", "nl", "ar" ];

const read = ( key ) => { try { return localStorage.getItem( key ); } catch( e ) { return null; } };

export function startDark() {
    const saved = read( "remedy-theme" );
    if( saved === "dark" || saved === "light" ) return saved === "dark";
    const h = new Date().getHours();
    return !( h >= 7 && h < 19 );
}

export function startLang() {
    const saved = read( "remedy-lang" );
    if( LANGS.includes( saved ) ) return saved;
    const nav = ( navigator.language || "fr" ).slice( 0, 2 );
    return LANGS.includes( nav ) ? nav : "fr";
}

// The sites of our solutions are on the same domain: they open in the language and the theme chosen here
export function save( key, value ) {
    for( const site of [ "remedy", "remedydoc", "remedyerp", "remedypos" ] ) {
        try { localStorage.setItem( site + "-" + key, value ); } catch( e ) {}
    }
}
